import { useEffect, useState } from 'react';
import axiosInstance from '../components/axiosInstance';

// Liest die Manager-Rolle (is_staff) aus dem zwischengespeicherten User —
// sofort verfuegbar — und frischt sie einmalig ueber /me/ nach, falls der
// Cache aus einer aelteren Sitzung noch kein is_staff enthaelt.
//
// Dient NUR dazu, Aktionen auszublenden, die der Server ohnehin nur
// Managern erlaubt (Security S3/S4). Die eigentliche Durchsetzung liegt im
// Backend — dies ist reine UX, kein Sicherheitsmechanismus.

function readCachedIsManager() {
  try {
    return !!JSON.parse(localStorage.getItem('user'))?.is_staff;
  } catch {
    return false;
  }
}

export default function useIsManager() {
  const [isManager, setIsManager] = useState(readCachedIsManager);

  useEffect(() => {
    let alive = true;
    axiosInstance
      .get('/me/')
      .then((res) => {
        if (!alive) return;
        setIsManager(!!res.data?.is_staff);
        // Cache aktualisieren, damit andere Seiten sofort korrekt sind.
        try {
          localStorage.setItem('user', JSON.stringify(res.data));
        } catch {
          /* localStorage nicht verfuegbar — Cache bleibt wie er ist */
        }
      })
      .catch(() => {
        /* nicht erreichbar/nicht eingeloggt — beim Cache-Wert bleiben */
      });
    return () => {
      alive = false;
    };
  }, []);

  return isManager;
}
